<template>
  <v-list dense :color="color">
    <v-list-item v-for="(val, i) in data" :key="i" class="litem">
      <h3>
        {{ val.descricao }} | {{ convertDecimalValue(val.total.toFixed(2)) }}
      </h3>
    </v-list-item>
  </v-list>
</template>
<script>
import Helpers from "@/mixins/helpers";
export default {
  mixins: [Helpers],
  props: ["data", "color"],
  created() {
    this.Helpers;
  },
};
</script>

<style>
.litem {
  font-size: 1.2rem;
  color: #fff;
  margin-bottom: 10px;
}

.litem h3 {
  font-weight: 400;
  color: #fff;
}
</style>